/*
 *  Copyright (c) 2011-2018 Acronis Incorporated. All rights reserved.
 *
 *  This source code may be used only by organizations licensed to use Acronis Access, in conjunction with normal Acronis Access usage.
 *  No portion of it may be redistributed or modified without the written permission of Acronis, Inc. See the Acronis Software License Agreement for more information.
 */

'use strict';

angular.module('access.Account')
    .directive('accChangeLanguage', ['$modal', '$translate', function($modal, $translate) {
        return {
            scope: {
                account: '=accChangeLanguage'
            },
            link: function($scope, $element) {
                $element.on('click', openChangeLanguage);

                function openChangeLanguage() {
                    $modal.open({
                        domOptions: {
                            modalType: 'confirm',
                            modalBodyTemplate: 'account/change_language',
                            modalTitle: $translate.instant('Change Language'),
                            modalActionButton: $translate.instant('Change Language')
                        },
                        controller: ['$scope', '$modalInstance', '$window', 'Settings', 'AccountResource',
                            function($modalScope, $modalInstance, $window, Settings, AccountResource) {
                                $modalScope.modal = $modalInstance.options;
                                $modalScope.account = $scope.account;
                                $modalScope.availableLocales = Settings['supported_locales'];

                                $modalScope.ok = function() {
                                    AccountResource.changeLanguage({locale: $modalScope.account.locale}).$promise
                                        .then(function() {
                                            $window.location.reload();
                                        })
                                        .finally($modalInstance.close);
                                };

                                $modalScope.close = $modalScope.cancel = function() {
                                    $modalInstance.dismiss('cancel');
                                };
                            }]
                    })
                }
            }
        }
    }]);
